import CategoryGridItem, { CategoryGridItemProps } from './CategoryGridItem'

export default CategoryGridItem

export { CategoryGridItem }
export type { CategoryGridItemProps }
